import { DataEntity } from '@barthauer/abc/graphics/adapters/open-layers';
import { RouteConfiguration } from '@barthauer/basys/map-frame';
import { ComponentDataSource, DataSourceFilter } from '../models/componentDataSource.model';
import { IMobileWork, MobileTaskViewModel, MobileWorkViewModel } from '../viewModels/mobileData.viewModel';
import { WorksService } from './works.service';

export class WorkConstants {
  public static readonly ObjectTypeName_MtWork: string = 'MtWork';
  public static readonly ObjectTypeName_MtTask: string = 'MtTask';
  public static readonly ObjectTypeName_MtResult: string = 'MtResult';
  public static readonly PersistenceCategory_WorkDetail: string = 'Tasks';
  public static readonly PersistenceCategory_TaskDetail: string = 'Results';
  public static readonly FlagFilter_ImmediateMeasure: string = 'FlagFilter_ImmediateMeasure';
  public static readonly DurationFormatString: string = '#########0 min';
}

export class WorksDataContext {
  dataSource: ComponentDataSource<IMobileWork>;
  selectedWorkStates: string[];

  isInAggregatedMode: boolean;

  constructor(private worksService: WorksService) {
    this.selectedWorkStates = [
      WorkState.Beauftragt.toString(),
      WorkState.Teilerledigt.toString(),
      WorkState.Erledigt.toString(),
      WorkState.Geplant.toString(),
      WorkState.Anstehend.toString(),
    ];
  }

  applyFilterObject(dsFilter: DataSourceFilter) {
    this.dataSource.addFilter(dsFilter);
    this.worksService.raiseWorkStateChanged({
      type: WorkStateChangeArgType.WorksFilterApplied,
    });
  }
  resetFilter() {
    this.selectedWorkStates = [
      WorkState.Beauftragt.toString(),
      WorkState.Teilerledigt.toString(),
      WorkState.Erledigt.toString(),
    ];
    this.dataSource.resetFilter();
  }
  updateFilter() {
    this.dataSource.updateFilter();
  }
}

export class WorkNavigationContext {
  workDataContext: WorksDataContext;
  workIndex?: number;
  taskIndex?: number;
  sourceRoute?: RouteConfiguration;
  workId?: string;
  autoOpen?: boolean;
  lastExpandedElementId?: string;
  validateDurationOnOpen?: boolean;

  get work(): MobileWorkViewModel {
    let work = null;
    work = this.findByWorkId(this.workId);
    if (!work) {
      if (this.workIndex || this.workIndex === 0) {
        work = this.workDataContext.dataSource.data[this.workIndex];
      }
    }
    return work;
  }

  get task(): MobileTaskViewModel {
    let task = null;
    if (this.taskIndex || this.taskIndex === 0) {
      const work: MobileWorkViewModel = this.work;
      if (work) {
        task = work.tasks[this.taskIndex];
      }
    }
    return task;
  }

  private findByWorkId(workId?: string): MobileWorkViewModel {
    let retWork: MobileWorkViewModel = undefined;

    if (workId) {
      const dataValues = Object.values(this.workDataContext.dataSource.data);
      for (let w of dataValues) {
        const wvm = w as any;
        const id = wvm?.id;

        if (id === workId) {
          retWork = w as MobileWorkViewModel;
          break;
        }
      }
    }

    return retWork;
  }
}

export enum WorkViewMode {
  AllFilteredByEntities = 1,
  AggregatedByEntityCategory,
  AllFilteredByWorkIds,
}

export class WorkViewPackage {
  mode: WorkViewMode;
  filterEntities: DataEntity[];
  filterWorkIds: string[];
  allWorks: MobileWorkViewModel[];
  allWorksFilteredByEntities: MobileWorkViewModel[];
  aggregatedWorks: MobileWorkViewModel[];
  pathNameOfAggregation: string;
}

export enum WorkState {
  Geplant = 0,
  Anstehend = 1,
  Beauftragt = 2,
  Teilerledigt = 3,
  Erledigt = 4,
}

export enum WorkTypeDurationMode {
  NichtRelevant = 0,
  Optional = 1,
  Erforderlich = 2,
}

export enum WorkStateChangeArgType {
  WorksFilterApplied,
}

export class WorkStateChangeArg {
  type: WorkStateChangeArgType;
}
